import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../../../config/firebase';

/**
 * Hook personalizado para gestionar la autenticación.
 * Proporciona una función para cerrar la sesión del usuario.
 */
export const useAuth = () => {
    const navigate = useNavigate();

    const logout = async () => {
        try {
            await signOut(auth);
            // Después de cerrar sesión, redirigimos al usuario a la página de login.
            navigate('/login');
        } catch (error) {
            console.error("Error al cerrar sesión:", error);
        }
    };

    return { logout };
};
